module.exports = __webpack_public_path__ + "static/media/hi.43ca7775.png";